/**
 * Verifica se uma senha atende a todos os critérios de segurança:
 * - Pelo menos 8 caracteres
 * - Pelo menos um caractere especial (!@#$%^&*(),.?":{}|<>)
 * - Pelo menos uma letra maiúscula
 * - Pelo menos uma letra minúscula
 * - Pelo menos um número
 *
 * @param password - A senha a ser validada
 * @returns boolean
 */
export const isPasswordValid = (password: string): boolean => {
  // Validação de comprimento mínimo
  if (password.length < 8) {
    return false;
  }

  // Validação de caractere especial
  if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
    return false;
  }

  // Validação de letra maiúscula
  if (!/[A-Z]/.test(password)) {
    return false;
  }

  // Validação de letra minúscula
  if (!/[a-z]/.test(password)) {
    return false;
  }

  // Validação de número
  if (!/[0-9]/.test(password)) {
    return false;
  }

  // Senha válida
  return true;
};
